import React, { StatelessComponent } from 'react';
import cls from '../utils/classnames';
import { GRID } from '../utils/classes';
import './_styles.scss';

export interface IGridProps {
    /**
     * optional className to add to wrapper
     */
    className?: string;
    onClick?: () => void;
    style?: object;
}

export const Grid: StatelessComponent<IGridProps> = props => {
    const { className, children, onClick, style } = props;
    const classNames = cls(GRID, className);
    return <div className={classNames} onClick={onClick} style={style}>{children}</div>;
};



// WEBPACK FOOTER //
// ./src/packages/components/lib/Grid/index.tsx